
























import { Component, Vue, Prop } from "vue-property-decorator";
import IActor from "../types/actor";
import { serverBase } from "../apollo";
import { contextModule } from "../store/context";
import moment from "moment";

@Component
export default class ActorGrid extends Vue {
  @Prop() value!: IActor[];
  @Prop() sceneDate?: number;
  @Prop({ default: 6 }) cols!: number;
  @Prop({ default: 6 }) sm!: number;
  @Prop({ default: 6 }) md!: number;
  @Prop({ default: 6 }) lg!: number;
  @Prop({ default: 6 }) xl!: number;

  calculateAge(actor: IActor) {
    if (actor.bornOn) {
      return moment(this.sceneDate).diff(actor.bornOn, "years");
    }
  }

  thumbnail(actor: IActor) {
    if (actor.thumbnail)
      return `${serverBase}/media/image/${
        actor.thumbnail._id
      }/thumbnail?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }
}
